@if (voucher(); as voucher) {
  <div class="layout-column full-height padding-20" appBringozIdGenerator="threepl-vouchers-print-page">

    <div class="layout-column padding-20">
      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600">{{ 'Voucher' | translate }}</span>
        <span class="br-body-2 font-weight-600">{{ voucher.threePlExtraData.name }} - {{ voucher.externalId || voucher.id }}</span>
        <span class="flex"></span>
        <span class="br-body-2 font-weight-600">{{ currentDate | bringozFullDate: 'currentDate' }} {{ currentDate | bringozTime: 'currentDate' }}</span>
      </div>
    </div>

    <bz-divider></bz-divider>

    <div class="layout-row layout-align-start-start voucher-details-container">
      <div class="flex br-caption-2 layout-column">
        <span class="br-body-2">זון שרותים לוגיסטיים הובלה פרוייקטים בת</span>
        <span class="br-body-2">הרב יקותיאל 25, מפרץ חיפה</span>
      </div>

      <div class="flex br-caption-2 layout-column">
        <div class="layout-row layout-align-start-center gap-5">
          <span class="br-body-2">{{ 'From' | translate }}:</span>
          <span class="br-body-2">{{ voucher.pickup?.address | bringozAddress }}</span>
        </div>
        <div class="layout-row layout-align-start-center gap-5">
          <span class="br-body-2">{{ 'To' | translate }}:</span>
          <span class="br-body-2">{{ voucher.destination?.address | bringozAddress }}</span>
        </div>
      </div>

      <div class="flex br-caption-2 layout-column">
        <div class="layout-row layout-align-start-center gap-5">
          <span class="br-body-2">{{ 'Creation Date' | translate }}:</span>
          <span class="br-body-2">{{ voucher | bringozFullDate: 'createdAt' }}</span>
        </div>
      </div>

      <div class="flex br-caption-2 layout-column">
        <div class="layout-row layout-align-start-center gap-5">
          <span class="br-body-2">{{ 'Phone' | translate }}:</span>
          <span class="br-body-2">04-8416266</span>
        </div>
        <div class="layout-row layout-align-start-center gap-5">
          <span class="br-body-2">{{ 'Fax' | translate }}:</span>
          <span class="br-body-2">04-8418864</span>
        </div>
      </div>
    </div>

    <div class="layout-column margin-bottom-20">
      <div class="layout-column table-container">
        <div class="tr br-body-2 font-weight-600 layout-row layout-align-start-center print-table-header">
          <div class="th flex-10">{{ 'Order' | translate }}</div>
          <div class="th flex-10">{{ 'Account' | translate }}</div>
          <div class="th flex">{{ 'UN' | translate }}</div>
          <div class="th flex">{{ 'VOUCHER_PRINT.IMO' | translate }}</div>
          <div class="th flex-10">{{ 'Weight' | translate }}</div>
          <div class="th flex">{{ 'VOUCHER_PRINT.E/F' | translate }}</div>
          <div class="th flex">{{ 'Length' | translate }}</div>
          <div class="th flex-10">{{ 'VOUCHER_PRINT.Package' | translate }}</div>
          <div class="th flex-10">{{ 'VOUCHER_PRINT.Barcode' | translate }}</div>
          <div class="th flex">{{ 'VOUCHER_PRINT.Cart' | translate }}</div>
          <div class="th flex">{{ 'VOUCHER_PRINT.LockNumber' | translate }}</div>
        </div>

        @for (container of containers(); track $index; let i = $index) {
          <div class="layout-row layout-align-start-center padding-5">
            <div class="td flex-10"><span class="br-body-2">#{{ i + 1 }} {{ container.omsOrderId }}</span></div>
            <div class="td flex-10 layout-column layout-align-center-start">
              <span class="br-body-2">{{ voucher.fulfillmentStepInfoList?.[0]?.accountReference?.name }}</span>
              <span class="br-body-2">{{ voucher.fulfillmentStepInfoList?.[0]?.accountReference?.phoneNumber | bringozPhone }}</span>
            </div>
            <div class="td flex">
              @if (container.unNumberInfo) {
                <span class="br-body-2">{{ container.unNumberInfo.id }} {{ container.unNumberInfo.description }}</span>
              }
            </div>
            <div class="td flex"><span class="br-body-2">{{ container.riskCode }}</span></div>
            <div class="td flex-10"><span class="br-body-2">{{ container.weight | bringozWeight }} {{ weightUnit | translate }}</span></div>
            <div class="td flex"><span class="br-body-2">{{ 'VOUCHER_PRINT.F' | translate }}</span></div>
            <div class="td flex"><span class="br-body-2">{{ container.containerType }}</span></div>
            <div class="td flex-10">
              <!-- ui-fallback: package items stay an admin component. Guarded: unlike the AngularJS one it throws without a type. -->
              @if (container.item?.type) {
                <app-bringoz-package-item [id]="container.item.type"></app-bringoz-package-item>
              }
            </div>
            <div class="td flex-10"><span class="br-body-2">{{ container.item?.barcode }}</span></div>
            <div class="td flex"><span class="br-body-2">{{ container.carId }}</span></div>
            <div class="td flex"><span class="br-body-2">{{ container.lockNumber }}</span></div>
          </div>
          <bz-divider></bz-divider>
        }
      </div>

      <div class="layout-row margin-top-20">
        <span class="flex"></span>
        <div class="layout-column layout-align-center-end">
          <div class="layout-row layout-align-start-center gap-10">
            <span class="br-body-2 font-weight-600">{{ 'Total Weight' | translate }}:</span>
            <span class="br-body-2 font-weight-600">{{ totals().totalWeight | bringozWeight }} {{ weightUnit | translate }}</span>
          </div>
          <div class="layout-row layout-align-start-center gap-30">
            <span class="br-body-2">20 {{ 'VOUCHER_PRINT.Empty' | translate }}:</span>
            <span class="br-body-2">{{ totals().empty20 }}</span>
          </div>
          <div class="layout-row layout-align-start-center gap-30">
            <span class="br-body-2">20 {{ 'VOUCHER_PRINT.Full' | translate }}:</span>
            <span class="br-body-2">{{ totals().full20 }}</span>
          </div>
          <div class="layout-row layout-align-start-center gap-30">
            <span class="br-body-2">40 {{ 'VOUCHER_PRINT.Empty' | translate }}:</span>
            <span class="br-body-2">{{ totals().empty40 }}</span>
          </div>
          <div class="layout-row layout-align-start-center gap-30">
            <span class="br-body-2">40 {{ 'VOUCHER_PRINT.Full' | translate }}:</span>
            <span class="br-body-2">{{ totals().full40 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
}
